import { useTranslation } from 'react-i18next'
import { Package } from 'lucide-react'
import { isToday, formatDateShort } from '../utils'

interface OrdersEmptyStateProps {
  date: Date
}

export function OrdersEmptyState({ date }: OrdersEmptyStateProps) {
  const { t } = useTranslation('orders')
  const isTodayDate = isToday(date)

  return (
    <div className="flex flex-col items-center justify-center h-full min-h-[300px] text-center p-8">
      <div className="relative mb-5">
        <div className="absolute inset-0 rounded-full bg-primary/10 blur-xl scale-125" aria-hidden />
        <div className="relative rounded-full bg-gradient-to-br from-accent to-primary/10 p-6 ring-1 ring-primary/15">
          <Package className="h-12 w-12 text-primary/70" />
        </div>
      </div>
      <h3 className="font-display text-lg font-bold mb-2">
        {isTodayDate ? t('empty.today') : t('empty.title')}
      </h3>
      <p className="text-muted-foreground max-w-sm">
        {isTodayDate
          ? t('empty.todayDescription')
          : t('empty.description', { date: formatDateShort(date) })}
      </p>
    </div>
  )
}
